import * as React from 'react'
import { ZH } from './zh'

type Vars = Record<string, string | number>

/** BCP 47 tag the surface reads in; the library's words and dates follow it. */
const UiLocaleContext = React.createContext('en-US')

/**
 * The words the library says on its own — a footer's Cancel, a calendar's month — follow the
 * surface's language, so a caller that never names them still reads in the viewer's language.
 * Without a provider they stay English.
 */
export function UiTextProvider({
  locale,
  children,
}: {
  locale: string
  children: React.ReactNode
}) {
  return <UiLocaleContext.Provider value={locale}>{children}</UiLocaleContext.Provider>
}

/** Takes the English as written, `{name}` placeholders included, and fills them from `vars`. */
export function useUiText(): (english: string, vars?: Vars) => string {
  const zh = React.useContext(UiLocaleContext).startsWith('zh')
  return React.useCallback(
    (english: string, vars?: Vars) => {
      const text = (zh && ZH[english]) || english
      return vars ? text.replace(/\{(\w+)\}/g, (hole, name) => String(vars[name] ?? hole)) : text
    },
    [zh]
  )
}

export function useUiLocale(): string {
  return React.useContext(UiLocaleContext)
}
